import { getOperatingEnv, getTargetEnv } from "../env/env"

export function getAdminEnv() {
  const env = getOperatingEnv()
  const adminEnv = getTargetEnv(env, {
    production: "prod",
    staging: "staging",
    development: "dev",
    testing: "testing"
  })

  return adminEnv
}

export function getAdminUrl(pathname: string = "") {
  const adminEnv = getAdminEnv()

  // Redirect to the pw admin SSO URL if it exists, first setting the ?next url.
  const url = new URL(`https://${adminEnv}.backend.pwadm.com/${pathname}`)

  return url
}
